import React from 'react'
import './Meet.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Rcs from "./SI-Handset-RCS-Hero.webp"
function Meet() {
  return (
    <div className='main'>
           <img src={Rcs} alt="Rcs" />
        <div className='content'>
            <p>RICH COMMUNICATIONS SERVICE (RCS)</p>
            <h2 className='mb-3 mb-lg-4 h3'>Enter a world of rich, engaging,<br/>
             messaging</h2>
             <p>Deliver branded, verified messages that feel like an app
            <br/> experience, straight in the user’s SMS inbox.</p>
            <button className="btns">Meet Sinch Rcs</button>
        </div>
    </div>
  )
}

export default Meet;